import { safeImageLoader, withSafeSrc } from '@core/utils';
import Image, { ImageProps } from 'next/image';
import { useEffect, useState } from 'react';

export const PLACEHOLDERS = {
  product: 'https://cdn.jhattse.com/public/consumer/placeholder/product_square.png',
  store: 'https://cdn.jhattse.com/public/consumer/placeholder/store.png',
};

interface SafeImageProps extends Omit<ImageProps, 'src'> {
  src?: ImageProps['src'] | null;
  fallback?: string;
}

// next/image that swaps to a placeholder when the source is missing or fails to load, so a dead
// URL never leaves a broken-image icon / alt text stretching its container.
export const SafeImage = ({ src, fallback = PLACEHOLDERS.product, onError, loader, ...rest }: SafeImageProps) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [src]);

  return (
    <Image
      {...rest}
      loader={loader ? withSafeSrc(loader, fallback) : safeImageLoader}
      src={failed || !src ? fallback : src}
      onError={(e) => {
        setFailed(true);
        onError?.(e);
      }}
    />
  );
};
